var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-dialog',{attrs:{"container":_vm.container,"title":_vm.title,"value":_vm.value},on:{"input":_vm.onInput}},[_vm._t("default"),_c('template',{slot:"actions"},[_c('close-button',{attrs:{"color":"primary"},on:{"click":_vm.close}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }